import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export function useAnalyticsModel(id: string | undefined) {
    return useQuery({
        queryKey: ['get-analytics-model', id],

        queryFn: () => {
            if (!id) {
                return null;
            }
            return sdClient.getAnalyticsModel({ modelId: id });
        },
    });
}
